// Central API client
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' },
});

export const setAuthToken = (token) => {
  if (token) {
    api.defaults.headers.common.Authorization = `Bearer ${token}`;
    localStorage.setItem('ad_token', token);
  } else {
    delete api.defaults.headers.common.Authorization;
    localStorage.removeItem('ad_token');
  }
};

const existing = localStorage.getItem('ad_token');
if (existing) {
  api.defaults.headers.common.Authorization = `Bearer ${existing}`;
}

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // Silent - AuthProvider handles logout
    }
    return Promise.reject(err);
  }
);

/**
 * Download a PDF report using the authenticated axios client and trigger a
 * browser save. This is necessary because a naive `<a href>` navigation
 * would not carry the JWT Authorization header and the backend would reject
 * the request with 401 "Not authenticated".
 *
 * @param {string} path - path relative to `/api`, e.g. `/reports/alert/{id}/pdf`
 * @param {string} filename - suggested file name for the download
 */
export const downloadPdf = async (path, filename) => {
  const res = await api.get(path, { responseType: 'blob' });
  const blob = new Blob([res.data], { type: 'application/pdf' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename || 'AakashDrishti_Report.pdf';
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Revoke the object URL after a short delay so the download can start
  setTimeout(() => window.URL.revokeObjectURL(url), 1000);
};

/**
 * Download any authenticated file (CSV, JSON, etc.) as a browser save.
 * Uses the authenticated axios client so JWT is included on the request.
 *
 * @param {string} path - path relative to `/api`, e.g. `/alerts/export`
 * @param {string} filename - suggested file name for the download
 * @param {object} params - optional query params
 */
export const downloadFile = async (path, filename, params) => {
  const res = await api.get(path, { params, responseType: 'blob' });
  const contentType = res.headers?.['content-type'] || 'application/octet-stream';
  const blob = new Blob([res.data], { type: contentType });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename || 'AakashDrishti_Export';
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => window.URL.revokeObjectURL(url), 1000);
};
